import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiStripepaymentgatewaySaveTransactionDetailMutationRequest,
  PostApiStripepaymentgatewaySaveTransactionDetailMutationResponse,
  PostApiStripepaymentgatewaySaveTransactionDetail401,
  PostApiStripepaymentgatewaySaveTransactionDetail403,
} from "../../../types/PostApiStripepaymentgatewaySaveTransactionDetail";

export function getPostApiStripepaymentgatewaySaveTransactionDetailUrl() {
  return `/api/StripePaymentGateway/save-transaction-detail` as const;
}

/**
 * {@link /api/StripePaymentGateway/save-transaction-detail}
 */
export async function postApiStripepaymentgatewaySaveTransactionDetail(
  data?: PostApiStripepaymentgatewaySaveTransactionDetailMutationRequest,
  config: Partial<
    RequestConfig<PostApiStripepaymentgatewaySaveTransactionDetailMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiStripepaymentgatewaySaveTransactionDetailMutationResponse,
    ResponseErrorConfig<
      | PostApiStripepaymentgatewaySaveTransactionDetail401
      | PostApiStripepaymentgatewaySaveTransactionDetail403
    >,
    PostApiStripepaymentgatewaySaveTransactionDetailMutationRequest
  >({
    method: "POST",
    url: getPostApiStripepaymentgatewaySaveTransactionDetailUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
